<div class="container" id="main-content" aria-label="Main Content">
    <div>
        <h1 tabindex="0" class="heading-title">{{'APPLICATION_DETAILS.TITLE' | translate}}</h1>
        <hr />
    </div>

    <div class="row no-focus" *ngIf="dynamicForm" tabindex="0">
        <div class="col-md-8 no-focus">
            <form [formGroup]="dynamicForm" autocomplete="off">
                <div class="card">
                    <div class="card-body">
                        <mat-card-title class="sub-heading" tabindex="0">
                            {{'APPLICATION_DETAILS.NUM_APPLICANTS' | translate}}
                        </mat-card-title>
                        <span class="mobile-center">{{'APPLICATION_DETAILS.SELECT_NUM_APPLICANTS' | translate}}</span>
                        <div class="form-row row">
                            <div class="form-group row col-sm-12 col-md-12 col-lg-12">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mobile-center">
                                    <ngb-rating [(rate)]="personQuantity" max="4" min="1" (click)="onChangeTickets()"
                                        (keydown.enter)="onChangeTickets()" (keydown.space)="onChangeTickets()"
                                        (hover)="hovered=$event" (leave)="hovered=personQuantity">
                                        <ng-template let-fill="fill" let-index="index">
                                            <i *ngIf="index < personQuantity" class="fas fa-user"
                                                [class.full]="fill === 100" [style.width.%]="fill"></i>
                                            <i *ngIf="index >= personQuantity" class="fas fa-user"
                                                [class.full]="fill === 100" [style.width.%]="fill"
                                                matTooltip="{{'APPLICATION_DETAILS.ADD_APPLICANT' | translate}}"
                                                aria-label="Add another applicant"></i>
                                        </ng-template>
                                    </ngb-rating>

                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 selected-div">
                                    <span class="selected-applicants">{{hovered}}</span>
                                    <br />
                                    <br />
                                    <span class="sub-heading">{{'COMMON.APPLICANTS' | translate}}</span>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="text-padding">
                                <span
                                    tabindex="0">{{'APPLICATION_DETAILS.CURRENT_APPS_SELECTED' | translate:{numberOfApplicants: personQuantity} }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-4" *ngIf="personQuantity > 0">
                    <div class="card-body">
                        <div *ngFor="let application of applicantArray.controls; let i = index" class="application">
                            <mat-card-title class="sub-heading" tabindex="0">{{'COMMON.APPLICANT' | translate}}
                                {{i + 1}}
                            </mat-card-title>
                            <span (click)="removeApplication(i)" class="delete-span"
                                matTooltip="{{'APPLICATION_DETAILS.REMOVE_APPLICATION' | translate}} {{i + 1}}"
                                aria-label="Removes application" tabindex="0"><i
                                    class="material-icons delete-icon">delete</i></span>
                            <hr />
                            <form [formGroup]="application" class="form-row" autocomplete="off">

                                <div class="form-group col-12">
                                    <div #completeFormError
                                        *ngIf="!application.valid && !application.expiredApplication">
                                        <p *ngIf="submitted && !application.valid && !application.expiredApplication"
                                            class="validation-msg">
                                            {{'FORMS.VALIDATION_MSG' | translate}}</p>
                                    </div>
                                    <div *ngFor="let question of application.bookingQuestions;">
                                        <div class="row row-blocks">
                                            <mat-checkbox
                                                *ngIf="question.visible && question.detail_type=='check' || question.visible && question.detail_type=='check-price'"
                                                formControlName="{{question.reference}}" class="col-sm-7"
                                                required="question.visible" required="question.required">
                                                <span *ngIf="question.required" aria-hidden="true"
                                                    class="mat-placeholder-required mat-form-field-required-marker">
                                                    *</span>
                                                <span
                                                    *ngIf="question.price == 0">{{question.name | translateSplit}}</span>
                                                <span tabindex="-1"
                                                    *ngIf="question.price > 0">{{question.name | translateSplit}} -
                                                    {{question.price / 100 |  currency:'EUR':true}}</span>
                                            </mat-checkbox>

                                            <p *ngIf="question.visible && question.help_text"
                                                class="help-text col-sm-7 mb-3" tabindex="0">
                                                {{question.help_text}}</p>
                                            <div *ngIf="question.visible && question.detail_type=='check' && submitted && application.controls[question.reference].errors || question.visible && question.detail_type=='check-price' && submitted && application.controls[question.reference].errors"
                                                class="col-sm-5 custom-error">
                                                <mat-error
                                                    *ngIf='application.controls[question.reference].errors.required'>
                                                    An answer is required
                                                </mat-error>
                                            </div>
                                        </div>

                                        <div class="row row-blocks">
                                            <mat-radio-group
                                                *ngIf="question.visible && question.detail_type=='radio' || question.visible && question.detail_type=='radio-price'"
                                                formControlName="{{question.reference}}" class="mt-2 mb-2 col-sm-7"
                                                required="question.required">
                                                <span *ngIf="question.required" aria-hidden="true"
                                                    class="mat-placeholder-required mat-form-field-required-marker">
                                                    *</span>
                                                <mat-label >{{question.name}}</mat-label>
                                                <div *ngFor="let option of question.options;">
                                                    <mat-radio-button *ngIf="!option.price" value="option.name"
                                                        tabindex="0">
                                                        {{option.name}}
                                                    </mat-radio-button>
                                                    <mat-radio-button *ngIf="option.price" value="option.name"
                                                        tabindex="0">
                                                        {{option.name}} - {{option.price}}</mat-radio-button>
                                                </div>
                                            </mat-radio-group>
                                            <div *ngIf="question.visible && question.detail_type=='check' && submitted && application.controls[question.reference].errors"
                                                class="col-sm-5 custom-error">
                                                <mat-error
                                                    *ngIf='application.controls[question.reference].errors.required'>
                                                    {{'FORMS.ANSWER_REQUIRED' | translate}}
                                                </mat-error>
                                            </div>
                                        </div>

                                        <div class="row row-blocks"
                                            *ngIf="question.visible && question.detail_type == 'select'">
                                            <label class="input-lbl col-sm-12">
                                                <span *ngIf="question.required" aria-hidden="true"
                                                    class="mat-placeholder-required mat-form-field-required-marker">
                                                    *</span>
                                                {{question.name | translateSplit}}</label>
                                            <mat-form-field appearance="outline" class="col-sm-7">
                                                <select matNativeControl
                                                    (change)="onQuestionChange($event, i, question.id)"
                                                    formControlName="{{question.reference}}" [value]='-1'>
                                                    <option></option>
                                                    <option *ngFor="let option of question.options"
                                                        [value]="option.name">
                                                        {{option.name | translateSplit}}
                                                    </option>
                                                </select>
                                            </mat-form-field>
                                            <div *ngIf="question.visible && question.detail_type == 'select' && submitted && application.controls[question.reference].errors"
                                                class="col-sm-5 custom-error">
                                                <mat-error tabindex="0"
                                                    *ngIf='application.controls[question.reference].errors.required'>
                                                    {{'FORMS.ANSWER_REQUIRED' | translate}}
                                                </mat-error>
                                            </div>
                                        </div>

                                        <div class="row row-blocks"
                                            *ngIf="question.visible && question.detail_type == 'text_field'">
                                            <label class="input-lbl col-sm-12">
                                                <span *ngIf="question.required" aria-hidden="true"
                                                    class="mat-placeholder-required mat-form-field-required-marker">
                                                    *</span>
                                                {{question.name | translateSplit}}</label>
                                            <mat-form-field appearance="outline" class="col-sm-7">
                                                <input matInput formControlName="{{question.reference}}">
                                            </mat-form-field>
                                            <div *ngIf="question.visible && question.detail_type == 'text_field' && submitted && application.controls[question.reference].errors"
                                                class="col-sm-5 custom-error">
                                                <mat-error tabindex="0"
                                                    *ngIf='application.controls[question.reference].errors.required || application.controls[question.reference].errors.pattern'>
                                                    {{'FORMS.ANSWER_REQUIRED' | translate}}
                                                </mat-error>
                                            </div>
                                        </div>

                                        <!-- date picker questions, not including DOB-->
                                        <div class="row row-blocks"
                                            *ngIf="question.visible && question.detail_type == 'date' && question.id !== 25">
                                            <label class="input-lbl col-sm-12"> <span aria-hidden="true"
                                                    class="mat-placeholder-required mat-form-field-required-marker">
                                                    *</span>
                                                {{question.name | translateSplit}}</label>
                                            <mat-form-field appearance="outline" class="col-sm-7">

                                                <input matInput formControlName="{{question.reference}}"
                                                    required="question.required" [matDatepicker]="picker" readonly
                                                    [max]="today" (ngModelChange)="checkTriageRules(undefined)">

                                                <mat-datepicker-toggle matSuffix [for]="picker">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #picker>
                                                </mat-datepicker>

                                            </mat-form-field>
                                            <div *ngIf="question.visible && question.detail_type == 'date' && submitted && application.controls[question.reference].errors"
                                                class="col-sm-5 custom-error">
                                                <mat-error tabindex="0"
                                                    *ngIf='application.controls[question.reference].errors.required'>
                                                    {{'FORMS.ANSWER_REQUIRED' | translate}}
                                                </mat-error>
                                            </div>
                                        </div>

                                        <!-- DOB -->
                                        <div *ngIf="question.id === 25" class="row-blocks">
                                            <app-custom-dob [applicantIndex]="i" [questionID]="question.id"
                                                [submitted]="submitted" [application]="application"
                                                (recallTriageRules)="customDobCheck($event)"
                                                (recallConditionalQuestionsCheck)="conditionalQCheck($event)"
                                                (recallQuestionCheck)="questionCheck($event)">
                                            </app-custom-dob>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div #error role="alert">
                    <div *ngIf="bornInIreland.length >= 1 ">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.BORN_IRELAND_DOB' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="expiredApplication.length >= 1 && applicantArray.length == 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.EXPIRED_APPLICATION_MSG' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="expiredApplication.length >= 1 && applicantArray.length > 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.EXPIRED_APPLICATION' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="adultFTAErr.length >= 1 && applicantArray.length == 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.ADULT_FTA_SINGLE' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="adultFTAErr.length >= 1 && applicantArray.length > 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.ADULT_FTA_MULTI' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="childFTANoCitizenship.length >= 1 && applicantArray.length > 0">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.CHILD_FTA_SINGLE' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="childFTA.length >= 1 && applicantArray.length > 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.CHILD_FTA_MULTI' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="invalidAdultDOBApplication.length >= 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.UNDERAGE_DOB' | translate | noSanitise"></span>
                        </div>
                    </div>

                    <div *ngIf="invalidChildDOBApplication.length >= 1">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg" tabindex="0"
                                [innerHTML]="'APPLICATION_DETAILS.OVERAGE_DOB' | translate | noSanitise"></span>
                        </div>
                    </div>
                </div>

                <div class="card mt-4" *ngIf="applicantArray.valid && applicantArray.controls.length > 0">
                    <div class="card-body">
                        <mat-card-title class="sub-heading" tabindex="0">{{'FORMS.SERVICE_REQUIRED' | translate}}
                        </mat-card-title>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <p *ngIf="submitted && dynamicForm.controls.serviceControl.errors"
                                    class="validation-msg">
                                    {{'FORMS.PLEASE_COMPLETE' | translate}}</p>
                                <div class="row">
                                    <label class="input-lbl col-sm-12">
                                        <span aria-hidden="true"
                                            class="mat-placeholder-required mat-form-field-required-marker">
                                            *</span>
                                        {{'FORMS.SERVICE_REQUIRED' | translate}}</label>
                                    <mat-form-field appearance="outline" class="col-sm-7">
                                        <select matNativeControl (change)="updateTotal()" tabindex="0"
                                            formControlName="serviceControl"
                                            [attr.disabled]="expiredApplication.length >= 1 || adultFTAErr.length > 0 || childFTA.length > 0 ? 'disabled' : null">
                                            <option value=""></option>
                                            <option *ngFor="let service of serviceList" [ngValue]="service">
                                                {{service?.name | translateSplit}}
                                            </option>
                                        </select>
                                    </mat-form-field>
                                    <div *ngIf="submitted && dynamicForm.controls.serviceControl.errors"
                                        class="col-sm-5">
                                        <mat-error *ngIf='dynamicForm.controls.serviceControl.errors.required'>
                                            {{'FORMS.TURNAROUND_TIME' | translate}}
                                        </mat-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div #serviceUnavailableError>
                    <div *ngIf="unavailableService && applicantArray.valid">
                        <div class="mt-4 alert-danger">
                            <span class="validation-msg"
                                [innerHTML]="'APPLICATION_DETAILS.CHILD_FTA_MULTI' | translate | noSanitise"></span>
                        </div>
                    </div>
                </div>

            </form>
        </div>

        <div class="col-md-4 mobile-summary">
            <mat-card>
                <app-booking-summary-card></app-booking-summary-card>
            </mat-card>
        </div>

        <div class="col-md-12 mt-4">
            <div class="form-group"
                *ngIf="applicantArray.controls.length > 0 && calendarReady && applicantArray.valid && !unavailableService"
                class="calendar-div">
                <app-calendar [service]="selectedService" [requiredAvailability]="personQuantity"
                    [tempBasket]="tempBasket" [dateLimit]="dateLimit" (loadIssue)="getCalendarLoadStatus($event)"
                    (slotsLength)="getSelectedSlotsLength($event)" (notBookableCheck)="getBoookableCheck($event)"
                    (onSelectDate)="checkSelectedDate($event)" (slotsCheck)="checkSlots($event)">
                </app-calendar>
            </div>

            <div #errUnderCalendar>
                <div *ngIf="slotsInPast && applicantArray.valid && calendarReady">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.INVALID_SLOTS' | translate | noSanitise"></span>
                    </div>
                </div>

                <div *ngIf="slotsInvalid && applicantArray.valid && calendarReady">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.INVALID_SLOTS_SELECTED' | translate | noSanitise"></span>
                    </div>
                </div>


                <div *ngIf="emergencyApplication && applicantArray.valid && applicantArray.length > 0">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.EMERGENCY_APPLICATION' | translate | noSanitise"></span>
                    </div>
                </div>

                <div *ngIf="onlineApplication && calendarReady">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.ONLINE_APPLICATION' | translate | noSanitise"></span>
                    </div>
                </div>

                <div *ngIf="emptySlots && confirmSelected && calendarReady">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.NO_SELECTED_SLOTS' | translate | noSanitise"></span>
                    </div>
                </div>

                <div *ngIf="invalidSlotsAmount && !emptySlots && confirmSelected && calendarReady">
                    <div class="mt-4 alert-danger">
                        <span class="validation-msg"
                            [innerHTML]="'APPLICATION_DETAILS.ADDITIONAL_SLOTS' | translate | noSanitise"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <button class="btn btn-primary" (click)="routerGoBack()">{{'COMMON.BACK' | translate}}</button>
        </div>
        <div class="col-6 text-right" *ngIf="!calendarReady">
            <button class="btn btn-primary" (click)="proceed()" [disabled]="invalidChildDOBApplication?.length > 0 ||
                invalidAdultDOBApplication?.length > 0 ||
                adultFTAErr?.length > 0 ||
                childFTA?.length > 0 ||
                emergencyApplication ||
                expiredApplication?.length > 0 ||
                unavailableService ||
                bornInIreland?.length > 0 ||
                applicantArray?.length === 0 ||
                childFTANoCitizenship.length > 0">{{'COMMON.PROCEED' | translate}}</button>
        </div>
        <div class="col-6 text-right" *ngIf="calendarReady">
            <button class="btn btn-primary" (click)="confirm()" [disabled]="calendarReady && emptySlots && confirmSelected || calendarReady && invalidSlotsAmount && confirmSelected || invalidChildDOBApplication.length > 0 ||
                invalidAdultDOBApplication.length > 0 ||
                adultFTAErr.length > 0 ||
                childFTA.length > 0 ||
                emergencyApplication ||
                expiredApplication.length > 0 ||
                unavailableService ||
                notBookable ||
                bornInIreland.length > 0 ||
                slotsInPast || slotsInvalid || applicantArray.invalid">{{'COMMON.PROCEED' | translate}}</button>
        </div>
    </div>
</div>